import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[spxChipListExpand]',
})
export class ChipListExpandDirective {
  @HostBinding('class.expand') isExpanded = false;

  @HostListener('click')
  onClick() {
    this.isExpanded = !this.isExpanded;
  }
}
